/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { JoinResponse } from './JoinResponse';
import {
    JoinResponseFromJSON,
    JoinResponseFromJSONTyped,
    JoinResponseToJSON,
} from './JoinResponse';

/**
 * 
 * @export
 * @interface SuccessResponseJoinResponse
 */
export interface SuccessResponseJoinResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SuccessResponseJoinResponse
     */
    status?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponseJoinResponse
     */
    timeStamp?: string;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponseJoinResponse
     */
    message?: SuccessResponseJoinResponseMessageEnum;
    /**
     * 
     * @type {JoinResponse}
     * @memberof SuccessResponseJoinResponse
     */
    data?: JoinResponse;
}


/**
 * @export
 */
export const SuccessResponseJoinResponseMessageEnum = {
    UserSignedUp: 'USER_SIGNED_UP',
    UserConfirmed: 'USER_CONFIRMED',
    UserComplete: 'USER_COMPLETE',
    WalletSaved: 'WALLET_SAVED',
    AlreadyConfirmed: 'ALREADY_CONFIRMED',
    AlreadyOnboarded: 'ALREADY_ONBOARDED',
    ResentConfirmationCode: 'RESENT_CONFIRMATION_CODE',
    Ok: 'OK'
} as const;
export type SuccessResponseJoinResponseMessageEnum = typeof SuccessResponseJoinResponseMessageEnum[keyof typeof SuccessResponseJoinResponseMessageEnum];


/**
 * Check if a given object implements the SuccessResponseJoinResponse interface.
 */
export function instanceOfSuccessResponseJoinResponse(value: object): boolean {
    return true;
}

export function SuccessResponseJoinResponseFromJSON(json: any): SuccessResponseJoinResponse {
    return SuccessResponseJoinResponseFromJSONTyped(json, false);
}

export function SuccessResponseJoinResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuccessResponseJoinResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'timeStamp': json['timeStamp'] == null ? undefined : json['timeStamp'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : JoinResponseFromJSON(json['data']),
    };
}

export function SuccessResponseJoinResponseToJSON(value?: SuccessResponseJoinResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': value['status'],
        'timeStamp': value['timeStamp'],
        'message': value['message'],
        'data': JoinResponseToJSON(value['data']),
    };
}

